import { DARK_TOKENS } from '../../theme/index.content';

export const TARGET_GRADIENT_TOKENS: Partial<Array<keyof typeof DARK_TOKENS>> =
  ['accentBackground', 'iconGrayScale'];
